import { useTranslation } from 'react-i18next';

import { IngredientTabProps } from 'components/desktop/Ingredient/IngredientComponent';
import FoldableCard from 'components/desktop/_general/Card/FoldableCard/FoldableCard';
import { RenderIf } from 'components/desktop/_general/Conditional/RenderIf';
import ItemListEditor from 'components/desktop/_general/ItemListEditor/ItemListEditor';
import ENTITLEMENTS from 'enums/entitlements';
import PERMISSIONS from 'enums/permissions';
import { arePermissionsInUserPermissions } from 'functions/tokenFunctions';
import * as SeasonList from 'types/_general/Store/SeasonList';

export const IngredientSeasonsCard = ({
	state,
	handlers,
	data,
}: IngredientTabProps): JSX.Element => {
	const { t } = useTranslation();
	const isIngredientEditor: boolean = arePermissionsInUserPermissions([
		PERMISSIONS.WRITEINGREDIENT,
	]);

	return (
		<RenderIf entitlements={[ENTITLEMENTS.SEASON]}>
			<FoldableCard
				defaultOpen={true}
				dataComponentType="ingredient-seasons-card"
				title={t('_general:SEASONS')}
				content={
					<>
						<div className="card-body">
							<ItemListEditor
								allItems={SeasonList.mapToItemList(data.seasons)}
								itemIds={state.seasonIds}
								setItemIds={handlers.setSeasonIds}
								readOnly={!isIngredientEditor}
								errorKey="Seasons"
								noItemsMessage={t('_general:NO_SEASONS')}
							/>
						</div>
					</>
				}
			/>
		</RenderIf>
	);
};
